(() => {
  'use strict';
  function init(root = document) {
    root.querySelectorAll('[data-heritage]:not([data-heritage-ready])').forEach(story => {
      const choices = [...story.querySelectorAll('[data-heritage-choice]')];
      const panels = [...story.querySelectorAll('[data-heritage-panel]')];
      if (!choices.length || choices.length !== panels.length) return;
      function select(index) {
        choices.forEach((choice, i) => choice.setAttribute('aria-pressed', String(i === index)));
        panels.forEach((panel, i) => { panel.hidden = i !== index; panel.open = i === index; });
        story.style.setProperty('--heritage-progress', `${index / Math.max(1, choices.length - 1) * 100}%`);
      }
      choices.forEach((choice, index) => {
        choice.addEventListener('click', () => select(index));
        choice.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % choices.length;
          if (event.key === 'ArrowLeft') next = (index + choices.length - 1) % choices.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = choices.length - 1;
          if (next === undefined) return;
          event.preventDefault(); choices[next].focus(); select(next);
        });
      });
      select(0); story.querySelector('.j-heritage__dates').hidden = false;
      story.dataset.heritageReady = 'true';
    });
  }
  init(); document.addEventListener('shopify:section:load', event => init(event.target));
})();
